function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  transform: "translate(-11760 -12065)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(11760 12065)",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-11760 -12065)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.1,1.834H9.833V1.268c0-.183-.2-.267-.383-.267H8.467A1.491,1.491,0,0,0,6.983,0,1.517,1.517,0,0,0,5.5,1H4.534c-.183,0-.367.083-.367.267v.567H2.9a1.417,1.417,0,0,0-1.4,1.35v9.549A1.341,1.341,0,0,0,2.9,14h8.2a1.341,1.341,0,0,0,1.4-1.267V3.184A1.417,1.417,0,0,0,11.1,1.834ZM4.834,1.668H5.75a.367.367,0,0,0,.317-.3.967.967,0,0,1,.917-.75.95.95,0,0,1,.9.75.367.367,0,0,0,.333.3h.95V3H4.834Zm7,11.066a.676.676,0,0,1-.733.6H2.9a.676.676,0,0,1-.733-.6V3.184A.75.75,0,0,1,2.9,2.5H4.167v.85a.35.35,0,0,0,.367.317H9.45a.367.367,0,0,0,.383-.317V2.5H11.1a.75.75,0,0,1,.733.683v9.549Z",
  fill: "#4f4f4f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.717,7.451a.333.333,0,0,0-.467-.017L4.184,8.45l-.45-.467a.333.333,0,0,0-.467-.017.35.35,0,0,0,0,.483l.683.7a.3.3,0,0,0,.233.1.333.333,0,0,0,.233-.1l1.3-1.233a.317.317,0,0,0,.019-.447Z",
  fill: "#4f4f4f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5,8.167H6.667a.333.333,0,0,0,0,.667H10.5a.333.333,0,1,0,0-.667Z",
  fill: "#4f4f4f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.717,4.784a.333.333,0,0,0-.467-.017L4.184,5.784l-.45-.467A.333.333,0,0,0,3.267,5.3a.35.35,0,0,0,0,.483l.683.7a.3.3,0,0,0,.233.1.333.333,0,0,0,.233-.1l1.3-1.233A.317.317,0,0,0,5.736,4.8Z",
  fill: "#4f4f4f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5,5.5H6.667a.333.333,0,0,0,0,.667H10.5a.333.333,0,1,0,0-.667Z",
  fill: "#4f4f4f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.717,10.117A.333.333,0,0,0,5.25,10.1L4.184,11.117l-.45-.467a.333.333,0,0,0-.467-.017.35.35,0,0,0,0,.483l.683.7a.3.3,0,0,0,.233.1.333.333,0,0,0,.233-.1l1.3-1.233a.317.317,0,0,0,.019-.447Z",
  fill: "#4f4f4f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5,10.834H6.667a.333.333,0,0,0,0,.667H10.5a.333.333,0,0,0,0-.667Z",
  fill: "#4f4f4f"
})));

function SvgGreenhouseEstimator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenhouseEstimator);
export default __webpack_public_path__ + "static/media/greenhouseEstimator.a6c72c96.svg";
export { ForwardRef as ReactComponent };